"use client";

import * as React from "react";
import { cn } from "~/lib/utils";

type HireSplitLayoutProps = {
  configPanel: React.ReactNode;
  previewPanel: React.ReactNode;
  className?: string;
};

export function HireSplitLayout({ configPanel, previewPanel, className }: HireSplitLayoutProps) {
  return (
    <div className={cn("flex min-h-0 w-full min-w-0 flex-1 flex-col", className)}>
      {/* Mobile: stacked with scroll */}
      <div className="flex min-h-0 w-full flex-1 flex-col gap-6 overflow-y-auto lg:hidden">
        {configPanel}
        {previewPanel}
      </div>

      {/* Desktop: full viewport width — left 1/3, right 2/3 */}
      <div className="hidden h-full min-h-0 w-full flex-1 grid-cols-[minmax(0,1fr)_minmax(0,2fr)] lg:grid">
        <div className="min-h-0 min-w-0 overflow-y-auto border-r border-slate-200 p-4 sm:p-5">
          {configPanel}
        </div>
        <div className="flex min-h-0 min-w-0 flex-col">{previewPanel}</div>
      </div>
    </div>
  );
}
